import { useState } from "react";
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Typography,
} from "@mui/material";
import { Box, Stack } from "@mui/system";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import FirtsTable from "./FirstTable/FirtsTable";
import SecondTable from "./Secondtable/SecondTable";
import ThirdTable from "./ThirdTable/ThirdTable";
import { useSelector } from "react-redux";

const Stonomalies = () => {
  const {
    campaignsWithoutScopeData,
    negativesInListAndInAdGroupData,
    negativesInTheCampaignData,
  } = useSelector((state: any) => state.searchTermOperation);
  // state to track which accordion is expanded
  const [expanded, setExpanded] = useState<string | false>(false);

  const handleChange =
    (panel: string) => (_event: React.SyntheticEvent, isExpanded: boolean) => {
      setExpanded(isExpanded ? panel : false);
    };

  return (
    <Box>
      {/* Header */}
      <Stack
        direction="column"
        justifyContent="space-between"
        alignItems="left"
        mt={1}
        mb={1}
      >
        <Typography variant="h5">Anomalies</Typography>
        <Typography variant="body2" gutterBottom color="text.secondary">
          Identify and resolve account-level anomalies in Negative Search Term
          configurations
        </Typography>
      </Stack>

      {/* Accordion */}
      {/* Campaigns without scope – 4  */}
      <Accordion
        expanded={expanded === "panel1"}
        onChange={handleChange("panel1")}
        sx={{
          "&.Mui-expanded": {
            margin: 0, // removes extra margin MUI adds to expanded Accordion
          },
          "& .MuiAccordionSummary-root": {
            minHeight: "48px",
          },
          "& .MuiAccordionSummary-root.Mui-expanded": {
            minHeight: "48px",
          },
          "& .MuiAccordionSummary-content": {
            margin: 0,
          },
          "& .MuiAccordionSummary-content.Mui-expanded": {
            margin: 0,
          },
        }}
      >
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel1bh-content"
          id="panel1bh-header"
          sx={{
            minHeight: "48px !important",
          }}
        >
          <Typography component="span" sx={{ width: "33%", flexShrink: 0 }}>
            Campaigns without scope –{" "}
            {campaignsWithoutScopeData.length > 0
              ? campaignsWithoutScopeData.length
              : 0}
          </Typography>
          <Typography component="span" sx={{ color: "text.secondary" }}>
            All enabled Campaigns that are not assigned to any scope
          </Typography>
        </AccordionSummary>
        <AccordionDetails>
          <FirtsTable />
        </AccordionDetails>
      </Accordion>
      {/* Negative definition in both list and adgroup – 5 */}
      <Accordion
        expanded={expanded === "panel2"}
        onChange={handleChange("panel2")}
        sx={{
          "&.Mui-expanded": {
            margin: 0, // removes extra margin MUI adds to expanded Accordion
          },
          "& .MuiAccordionSummary-root": {
            minHeight: "48px",
          },
          "& .MuiAccordionSummary-root.Mui-expanded": {
            minHeight: "48px",
          },
          "& .MuiAccordionSummary-content": {
            margin: 0,
          },
          "& .MuiAccordionSummary-content.Mui-expanded": {
            margin: 0,
          },
        }}
      >
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel1bh-content"
          id="panel1bh-header"
        >
          <Typography component="span" sx={{ width: "33%", flexShrink: 0 }}>
            Negative definition in both list and adgroup –{" "}
            {negativesInListAndInAdGroupData.length > 0
              ? negativesInListAndInAdGroupData.length
              : 0}
          </Typography>
          <Typography component="span" sx={{ color: "text.secondary" }}>
            Search terms with duplication of negative definitions
          </Typography>
        </AccordionSummary>
        <AccordionDetails>
          <SecondTable />
        </AccordionDetails>
      </Accordion>
      {/* Negative definition in campaign – 5 */}
      <Accordion
        expanded={expanded === "panel3"}
        onChange={handleChange("panel3")}
        sx={{
          "&.Mui-expanded": {
            margin: 0, // removes extra margin MUI adds to expanded Accordion
          },
          "& .MuiAccordionSummary-root": {
            minHeight: "48px",
          },
          "& .MuiAccordionSummary-root.Mui-expanded": {
            minHeight: "48px",
          },
          "& .MuiAccordionSummary-content": {
            margin: 0,
          },
          "& .MuiAccordionSummary-content.Mui-expanded": {
            margin: 0,
          },
        }}
      >
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel1bh-content"
          id="panel1bh-header"
        >
          <Typography component="span" sx={{ width: "33%", flexShrink: 0 }}>
            Negative definition in campaign –{" "}
            {negativesInTheCampaignData.length > 0
              ? negativesInTheCampaignData.length
              : 0}
          </Typography>
          <Typography component="span" sx={{ color: "text.secondary" }}>
            Search terms with negative definition at the campaign level (bad
            practice)
          </Typography>
        </AccordionSummary>
        <AccordionDetails>
          <ThirdTable />
        </AccordionDetails>
      </Accordion>
    </Box>
  );
};

export default Stonomalies;
